import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  TableContainer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import VantageListHead from "../../../../../../component/ListHead/SignalList";
import { Tablecell, applySortFilter, getComparator } from "../../../../../../component/Methods";

const SwapValidator = ({
  filteredContracts,
  tableHeader,
  hasValidationErrors,
}) => {
  const theme = useTheme();

  const [data, setData] = useState([]);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("name");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  useEffect(() => {
    const transformedData = filteredContracts?.flatMap((contract) => {
      if (!contract?.validationErrors) return [];

      return contract?.validationErrors?.map((param) => ({
        name: contract.name,
        id: contract.id,
        success: contract.success,
        reason: param.validationText.join(", "),
        ticker: param.ticker?.symbol,
      }));
    });

    const filteredUsers = applySortFilter(
      transformedData,
      getComparator(order, orderBy)
    );

    setData(filteredUsers);
  }, [order, orderBy, filteredContracts, hasValidationErrors]);

  return (
    <>
      {data && data?.length > 0 ? (
        <Box
          sx={{
            border: `100px ${theme.palette.lightGrey.tableHeader}`,
            borderRadius: "4px",
            marginTop: "20px",
            width: "100%",
          }}
        >
          <TableContainer style={{ height: "700px" }}>
            <Table
              size="small"
              stickyHeader
              aria-label="a dense table"
              sx={{
                height: "max-content",
              }}
            >
              <VantageListHead
                order={order}
                orderBy={orderBy}
                headLabel={tableHeader}
                noStatus={true}
                customizeFont={12}
                rowCount={data.length}
                onRequestSort={handleRequestSort}
              />

              <TableBody>
                {data?.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:hover": {
                        background: theme.palette.grey[200],
                        cursor: "pointer",
                      },
                    }}
                  >
                    <Tablecell
                      align="left"
                      style={{
                        fontSize: "12px",
                        paddingLeft: "5px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {row?.name}
                    </Tablecell>
                    <Tablecell
                      align="left"
                      style={{
                        fontSize: "12px",
                        paddingLeft: "5px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {row?.ticker?.toUpperCase() || ""}
                    </Tablecell>
                    <Tablecell
                      align="left"
                      style={{
                        fontSize: "12px",
                        paddingLeft: "5px",
                        borderLeft: "none",
                        borderRight: "none",
                        color: theme.palette.text.primary,
                        borderColor: theme.palette.divider,
                      }}
                    >
                      {row?.reason && row.reason.trim() !== "" &&
                        <List
                          dense
                          disablePadding
                          sx={{ listStyleType: "disc", pl: 2 }}
                        >
                          {row?.reason?.split(", ").map((text, idx) => (
                            <ListItem
                              key={idx}
                              disablePadding
                              sx={{ display: "list-item" }}
                            >
                              <ListItemText
                                primary={text}
                                primaryTypographyProps={{ fontSize: "12px" }}
                              />
                            </ListItem>
                          ))}
                        </List>
}
                    </Tablecell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : null}
    </>
  );
};

export default SwapValidator;
